import moment from 'moment';
import { IInvoice } from './invoices.interface';

export const initialContext = {
    loading: false,
    loadingAction: false,
    data: [] as IInvoice[],
    item: null as IInvoice | null,
    total: 0,
    paginator: {
        limit: 10,
        page: 1,
    },
    date: moment().startOf('day').toISOString(),
    searchParams: {},
    selectedRowKeys: [] as React.Key[],
    selectedColumns: [] as string[],
    fetchData: () => {},
    fetchItem: () => {},
    setLoading: () => {},
    setItem: () => {},
    setData: () => {},
    handleStatus: () => { },
    handleFrequency: () => { },
    handleGateway: () => { },
    handleDate: () => { },
    handleSearch: () => { },
    handleInvoiceId: () => { },
    handleType: () => { },
    onPageChange: () => {},
    setSelectedRowKeys: () => {},
    downloadInvoices: () => {},
    handleSelectedColumns: () => {},
    handleNewInvoice: () => {},
};
